// extracted by mini-css-extract-plugin
export default {"title":"_55c36b65ea","bld":"ad1162682c"};